import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import 'hammerjs';
if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));

//string
String.prototype['toNumber'] = function(){
  let str = <string> this;
  let num = str.replace(/,/g, '');
  return +num;
}
Object.defineProperty(String.prototype, 'initials',{ get: function initials() { return this.split(' ').reduce((acc, cur) => `${acc}${cur[0] || ''}`, '') } });

//number
Number.prototype['between'] = function(min: number, max: number, equals: boolean = false){
  return equals ? this >= min && this <= max : this > min && this < max;
}

//array
Object.defineProperty(Array.prototype, 'equals', {enumerable: false, value: function(a2: any[], strict: boolean = false){
  let a1 = <any[]> this;
  return a1.length == a2.length && a1.every((item, index) => strict ? item === a2[index] : item == a2[index] );
}})
Object.defineProperty(Array.prototype, 'cleanPush', {enumerable: false, value: function (element: any){
  let a = <any[]> this;
  if(!a.includes(element)) this.push(element);
  return element;
}})


Object.defineProperty(Array.prototype, 'last',{ get: function last() { return this[this.length-1] } })


let {hostname: hn} = location;
if(hn == 'sireilusa.firebaseapp.com' || hn == 'sireilusa.web.app') window.location.replace('https://sireilusa.com');
if(hn == 'sire-web.firebaseapp.com' || hn == 'sire-web.web.app') window.location.replace('https://sireiocsa.com');